// Library methods
import { ReactNode } from "react";

// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

// Styles
import { getRequiredErrorColor } from "src/styles/mui/muiStylesHelper";

type FormFieldType = {
  label: string;
  htmlFor?: string;
  labelId?: string;
  required?: boolean;
  children: ReactNode;
};

const FormField = ({
  label,
  htmlFor,
  labelId,
  required,
  children,
}: FormFieldType) => {
  const theme = useTheme();

  return (
    <Box display="flex" flexDirection="column" gap="4px" flex={1} minWidth={0}>
      <Typography
        component="label"
        id={labelId}
        htmlFor={htmlFor}
        fontSize="12px"
      >
        {label}
        {required && (
          <span style={{ color: getRequiredErrorColor(theme) }}>*</span>
        )}
      </Typography>
      {children}
    </Box>
  );
};

export default FormField;
